import styled, { css } from 'styled-components'

import theme from 'theme_'
import { H5 } from 'components/Typography'
import { TableWithPaginationWrapper } from 'components/Table/styles'
import { CommonButton } from 'components/Button'

export const HomeLogsSpinnerContainer = styled(H5)`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StyledHomeLogsHeader = styled.header`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${theme.spacing.base};

  @media ${theme.devices.tablet} {
    flex-wrap: nowrap;
    margin-bottom: 0;
  }
`

export const StyledCheckBoxRow = styled.header`
  margin: 10px;
`

export const StyledResolutionTitle = styled.header`
  margin: 20px 10px 10px 10px;
  font-weight: 900;
`

export const StyledHomeLogsInfo = styled.div`
  width: 100%;
  justify-content: space-between;
  display: flex;
  align-items: center;

  @media ${theme.devices.tablet} {
    justify-content: flex-start;
  }
`

export const StyledHomeLogsInfoName = styled.div`
  width: 100%;
  justify-content: space-between;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  @media ${theme.devices.tablet} {
    justify-content: flex-start;
  }
`

export const StyledLogsContentBtnsWrap = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: ${theme.spacing.base};

  @media ${theme.devices.tablet} {
    width: auto;
  }
`

export const StyledLogsInnerContainer = styled.div`
  position: relative;
`

export const HomeLogsUIDCellStyles = css`
  text-transform: uppercase;
`

export const HomeLogsTableInnerWrapper = styled.div`
  @media ${theme.devices.tablet} {
    min-width: 1000px;
  }
`

export const HomeLogsTableOuterWrapper = styled(TableWithPaginationWrapper)`
  @media ${theme.devices.tablet} {
    margin-bottom: 24px;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.02);
    border-radius: 8px;
  }
`

export const HomeLogsButton = styled(CommonButton)`
  padding: ${theme.spacing.s} ${theme.spacing.md};
`
export const TemplatesMobileBlockKebabItemWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: ${theme.spacing.xs};
`

export const RadioFieldItemWrapper = styled.div`
  display: flex;
`

export const RadioFieldTextWrapper = styled.div`
  margin: 10px;
`

export const AllHistoryWrapper = styled.div`
  margin: 27px;
`
